<template>
  <div>
    <AppSwitch
      v-if="editable"
      :value="value.showInCatalog"
      label="Show In Catalog"
      class="mb-2"
      @input="updateFormProperty({
        property: nestedMode ? `specializations.${index}.showInCatalog` : 'showInCatalog',
        value: $event
      })"
    />
    <DynamicForm
      :formId="formId"
      :isNested="true"
      :editable="editable"
    />
    <AppButton
      v-if="editable"
      variant="danger"
      class="mt-4"
      :raised="true"
      @click="$emit('delete')"
    >
      <AppIcon
        name="delete"
        class="mr-2"
      /> Delete Specialization
    </AppButton>
  </div>
</template>

<script>
import { toRefs, computed, provide, inject } from '@vue/composition-api'
import useDynamicForm from '@/components/DynamicForms/useDynamicForm'
import { programSpecializationsUtils } from '@coursedog/programSpecializations'
import useDataSources from '@/components/DynamicForms/useDataSources'

const { truncate } = require('@shared/utils/string')

export default {
  components: {
    DynamicForm: () => import('@/components/DynamicForms/DynamicForm'),
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      required: true,
    },
    formValue: {
      type: Object,
      default: () => ({}),
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { root, emit }) {
    const { config, formValue, value } = toRefs(props)
    const path = computed(() => `specializations.${props.index}`)

    const emitChanges = () => emit('input', value.value)

    const { addLocalSourceData } = useDataSources({ overrideLocalSources: true })
    addLocalSourceData('record', value)

    const dynamicFieldQuestionPath = inject('dynamic_field_question_path', [])
    const dynamicFieldValuePath = inject('dynamic_field_value_path', dynamicFieldQuestionPath)
    provide('dynamic_field_value_path', [ ...dynamicFieldValuePath, props.index ])

    function customizeField (question, formValue) {
      const questionCustomized = { ...question, placeholder: truncate(`Enter ${question.label}`, 26) }
      switch (question.questionId) {
        case 'effectiveEndDate':
          return {
            ...questionCustomized,
            ...({
              config: {
                ...questionCustomized.config,
                disabledDates: {
                  to: '$$effectiveStartDate',
                },
              },
            }),
          }
        default:
          return questionCustomized
      }
    }

    const questions = computed(() => Object.values(config.value.fields).map((q) => customizeField(q, value)))

    const {
      templateWithHiddenFields: template,
    } = programSpecializationsUtils(config.value.fields, root.$store.getters.user)

    const { formId, $v, update: updateFormProperty } = useDynamicForm({
      questions,
      template,
      onUpdated: emitChanges,
      formValue: props.nestedMode ? formValue : value,
      path: props.nestedMode ? path : undefined,
    })

    return {
      formId,
      $v,
      updateFormProperty,
    }
  },
}
</script>
